import { useState, useCallback } from 'react';
import { useBetween } from 'use-between';

function DocHeaderHook() {
  const [titleKey, setTitleKey] = useState("");
  const [metaDescKey, setMetaDescKey] = useState("");
  const [routerId, setRouterId] = useState("");
  const doSetTitleKey = useCallback((newTitleKey) => setTitleKey(newTitleKey), []);
  const doSetMetaDescKey = useCallback((newMetaDescKey) => setMetaDescKey(newMetaDescKey), []);
  const doSetRouterId = useCallback((newRouterId) => setRouterId(newRouterId), []);

  return {
    titleKey,
    metaDescKey,
    routerId,
    doSetTitleKey,
    doSetMetaDescKey,
    doSetRouterId
  };
};
const useSharedDocHeader = () => useBetween(DocHeaderHook);

export default useSharedDocHeader;
